import { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { FilePdf, ArrowSquareOut, Copy } from "@phosphor-icons/react";
import { toast } from "sonner";

const LIVE = "https://flash-grants.com";

const DocRow = ({ d }) => {
  const url = `${window.location.origin}/${d.file}?v=${d.v}`;
  const live = `${LIVE}/${d.file}?v=${d.v}`;
  return (
    <Card className="bg-zinc-950 border-zinc-800" data-testid={`doc-row-${d.file}`}>
      <CardContent className="p-4 flex flex-wrap items-center gap-3 justify-between">
        <div className="min-w-0">
          <p className="text-white font-semibold truncate">{d.title}</p>
          <p className="text-zinc-500 text-xs">{d.file} · updated {d.updated}</p>
        </div>
        <div className="flex gap-2">
          <Button size="sm" onClick={() => window.open(url, "_blank", "noopener")} data-testid={`doc-open-${d.file}`}>
            <ArrowSquareOut className="mr-1" /> Open
          </Button>
          <Button size="sm" variant="outline" data-testid={`doc-copy-${d.file}`}
            onClick={() => { navigator.clipboard.writeText(live); toast.success("Live link copied"); }}>
            <Copy className="mr-1" /> Copy live link
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default function AdminDocuments() {
  const [docs, setDocs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    fetch(`/docs-manifest.json?t=${Date.now()}`).then((r) => r.json()).then(setDocs).catch(() => toast.error("Could not load documents"));
  }, []);

  const shown = docs.filter((d) => `${d.title} ${d.file}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <AdminLayout>
      <div className="space-y-6" data-testid="admin-documents-page">
        <div>
          <h1 className="text-3xl font-black text-white flex items-center gap-3">
            <FilePdf weight="duotone" className="w-8 h-8 text-emerald-500" /> Documents
          </h1>
          <p className="text-zinc-400 mt-1">Every PDF on the site, newest first. "Open" opens it in a new tab; "Copy live link" copies the flash-grants.com link to send.</p>
        </div>
        <Input placeholder="Search documents..." value={q} onChange={(e) => setQ(e.target.value)} className="bg-zinc-900 border-zinc-700 text-white max-w-md" data-testid="docs-search" />
        <div className="space-y-3">{shown.map((d) => <DocRow key={d.file} d={d} />)}</div>
      </div>
    </AdminLayout>
  );
}
